import React from "react";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import { Button } from "@progress/kendo-react-buttons";
import DeleteIcon from "@material-ui/icons/Delete";
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { Field } from "@progress/kendo-react-form";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { connect } from "react-redux";

class Waste extends React.Component {
  constructor(props) {
    super(props);
    this.qtyTimeOut = null;
    this.otherItemTimeOut = null;
    this.otherUnitTimeOut = null;
    this.otherReasonTimeOut = null;
    this.parameters = null;
    this.format = "YYYY-MM-DDTHH:mm:00.000Z";
    this.state = {
      showWaste: false,
      qty: "0.0",
      items: [],
      reasons: [],
      units: [],
      data: [],
    };
  }

  createNew = () => {
    let defaultItem = this.parameters.items[0];
    let obj = {
      id: uuidv4(),
      time: moment(new Date()).format(this.format),
      qty: "0.0",
      item: defaultItem,
      otherItem: {
        status: defaultItem.value == "Other" ? true : false,
        value: null,
      },
      unit: this.parameters.units[0],
      otherUnit: {
        status: defaultItem.value == "Other" ? true : false,
        value: null,
      },
      reason: this.parameters.reasons[0],
      otherReason: {
        status: defaultItem.value == "Other" ? true : false,
        value: null,
      },
    };
    return obj;
  };

  componentDidMount() {
    this.parameters = JSON.parse(this.props.task.taskTemplate.parameters);
    if (this.parameters != null) {
      this.setState({
        items: this.parameters.items,
        reasons: this.parameters.reasons,
        units: this.parameters.units,
      });
    }
    let data = [];
    if (!this.props.isEditMode && !this.props.isDeleteMode) {
      data.push(this.createNew());
    } else {
      if (this.props.task.checklistTask.jsonValue) data = JSON.parse(this.props.task.checklistTask.jsonValue);
    }
    this.setState({
      data: data,
    });
    setTimeout(() => {
      this.onSave();
    }, 1000);
  }

  componentWillUnmount() { }

  editWaste = (e) => {
    let status = this.state.showWaste;
    this.setState({
      showWaste: !status,
    });
  };

  onTimeChange = (e) => {
    let id = e.target.props["data-value"];
    let tmps = this.state.data;
    tmps.map((item) => {
      if (item.id == id) {
        let dt = new Date(e.target.value);
        item.time = moment(dt).format(this.format);
      }
      return item;
    });
    this.setState({
      data: tmps,
    });
    this.onSave();
  };

  onQtyChange = (e) => {
    if (this.qtyTimeOut != null) {
      clearTimeout(this.qtyTimeOut);
      this.qtyTimeOut = null;
    }
    this.qtyTimeOut = setTimeout(() => {
      let id = e.target.props["data-value"];
      let tmps = this.state.data;
      tmps.map((item) => {
        if (item.id == id) {
          item.qty = e.target.value;
        }
        return item;
      });
      this.setState({
        data: tmps,
      });
      this.onSave();
    }, 1000);
  };

  onItemChange = (e) => {
    let id = e.target.props["data-value"];
    let tmps = this.state.data;
    let status = e.target.value.value == "Other";
    tmps.map((item) => {
      if (item.id == id) {
        item.item = e.target.value;
        item.otherItem.status = status;
      }
      return item;
    });
    this.setState({
      data: tmps,
    });
    this.onSave();
  };

  onOtherItemChange = (e) => {
    if (this.otherItemTimeOut != null) {
      clearTimeout(this.otherItemTimeOut);
      this.otherItemTimeOut = null;
    }
    this.otherItemTimeOut = setTimeout(() => {
      let id = e.target.props["data-value"];
      let tmps = this.state.data;
      tmps.map((item) => {
        if (item.id == id) {
          item.otherItem.value = e.target.value;
        }
        return item;
      });
      this.setState({
        data: tmps,
      });
      this.onSave();
    }, 1000);
  };

  onUnitChange = (e) => {
    let id = e.target.props["data-value"];
    let tmps = this.state.data;
    let status = e.target.value.value == "Other";
    tmps.map((item) => {
      if (item.id == id) {
        item.unit = e.target.value;
        item.otherUnit.status = status;
      }
      return item;
    });
    this.setState({
      data: tmps,
    });
    this.onSave();
  };

  onOtherUnitChange = (e) => {
    if (this.otherUnitTimeOut != null) {
      clearTimeout(this.otherUnitTimeOut);
      this.otherUnitTimeOut = null;
    }
    this.otherUnitTimeOut = setTimeout(() => {
      let id = e.target.props["data-value"];
      let tmps = this.state.data;
      tmps.map((item) => {
        if (item.id == id) {
          item.otherUnit.value = e.target.value;
        }
        return item;
      });
      this.setState({
        data: tmps,
      });
      this.onSave();
    }, 1000);
  };

  onReasonChange = (e) => {
    let id = e.target.props["data-value"];
    let tmps = this.state.data;
    let status = e.target.value.value == "Other";
    tmps.map((item) => {
      if (item.id == id) {
        item.reason = e.target.value;
        item.otherReason.status = status;
      }
      return item;
    });
    this.setState({
      data: tmps,
    });
    this.onSave();
  };

  onDelete = (e) => {
    let status = e.target.checked;
    let guid = e.currentTarget.getAttribute("data-value");
    let temps = this.state.data;
    temps.map((item) => {
      if (item.id == guid) {
        item.selected = status;
      }
      return item;
    });
    this.setState({
      data: temps,
    });
    this.onSave();
  };

  onOtherReasonChange = (e) => {
    if (this.otherReasonTimeOut != null) {
      clearTimeout(this.otherReasonTimeOut);
      this.otherReasonTimeOut = null;
    }
    this.otherReasonTimeOut = setTimeout(() => {
      let id = e.target.props["data-value"];
      let tmps = this.state.data;
      tmps.map((item) => {
        if (item.id == id) {
          item.otherReason.value = e.target.value;
        }
        return item;
      });
      this.setState({
        data: tmps,
      });
      this.onSave();
    }, 1000);
  };

  addItem = (e) => {
    let tmps = this.state.data;
    tmps.push(this.createNew());
    this.setState({
      data: tmps,
    });
    setTimeout(() => {
      this.onSave();
    }, 1000);
  };

  onSave = (e) => {
    let objs = [];
    let tmps = this.state.data;
    tmps.map((item) => {
      if (item.selected == undefined) {
        objs.push(item);
      } else {
        if (!item.selected) {
          delete item.selected;
          objs.push(item);
        }
      }
      return item;
    });
    let o = {
      templateName: this.props.templateName,
      sequence: this.props.sequence,
      value: JSON.stringify(objs),
    };
    this.props.onChange(o);
  };

  render() {
    let panel = (
      <>
        <tr className={"k-master-row"}>
          <td
            style={{
              verticalAlign: "top",
              paddingLeft: 5,
            }}
          >
            {this.props.task.taskTemplate.name}
          </td>
          <td
            style={{
              verticalAlign: "top",
              paddingLeft: 5,
            }}
          >
            {this.props.task.taskTemplate.description}
          </td>
          <td
            style={{
              verticalAlign: "top",
              textAlign: "right",
              paddingLeft: 5,
            }}
          >
            <Button
              type="button"
              id={"Edit" + this.props.sequence}
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "25% 25%",
                marginTop: "2px",
                marginBottom: "2px",
              }}
              className="buttons-container-button"
              icon="edit"
              disabled={this.props.isDeleteMode}
              onClick={this.editWaste}
            />
          </td>
        </tr>
        {this.state.showWaste.toString() === "true" && (
          <tr id={uuidv4()} className={"k-master-row"}>
            <td colSpan="3" align={"left"}>
              <table
                border={"0"}
                cellPadding={"1"}
                cellSpacing={"1"}
                width={"100%"}
              >
                <thead>
                  <tr key={uuidv4()}>
                    <td align="center" width={"20%"}>
                      <label>
                        <b>Time</b>
                      </label>
                    </td>
                    <td align="center" width={"20%"}>
                      <label>
                        <b>Item</b>
                      </label>
                    </td>
                    <td align="center" width={"10%"}>
                      <label>
                        <b>Qty</b>
                      </label>
                    </td>
                    <td align="center" width={"15%"}>
                      <label>
                        <b>Unit</b>
                      </label>
                    </td>
                    <td align="center">
                      <label>
                        <b>Reason</b>
                      </label>
                    </td>
                    <td align="center" valign="middle" width={"2%"}>
                      <DeleteIcon style={{ marginTop: "7px" }} />
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.map((item) => {
                    let theTime = new Date(item.time);
                    return (
                      <tr key={uuidv4()}>
                        <td valign="top">
                          <Field
                            component={TimePicker}
                            key={"Time" + item.id}
                            id={"Time" + item.id}
                            name={"Time" + item.id}
                            format="hh:mm a"
                            data-value={item.id}
                            value={theTime}
                            defaultValue={theTime}
                            onChange={this.onTimeChange}
                          />
                        </td>
                        <td valign="top">
                          <Field
                            component={DropDownList}
                            key={"Item" + item.id}
                            id={"Item" + item.id}
                            name={"Item" + item.id}
                            data={this.state.items}
                            data-value={item.id}
                            textField={"value"}
                            onChange={this.onItemChange}
                            defaultValue={item.item}
                            value={item.item}
                            required={true}
                          />
                          {item.otherItem.status && (
                            <Field
                              style={{
                                marginTop: "5px",
                                width: "100%",
                                backgroundColor: "#d9d9d9",
                              }}
                              component={Input}
                              data-value={item.id}
                              defaultValue={item.otherItem.value}
                              value={item.otherItem.value}
                              onChange={this.onOtherItemChange}
                            />
                          )}
                        </td>
                        <td valign="top">
                          <Field
                            component={Input}
                            key={"Qty" + item.id}
                            id={"Qty" + item.id}
                            name={"Qty" + item.id}
                            data-value={item.id}
                            defaultValue={item.qty}
                            value={item.qty}
                            onChange={this.onQtyChange}
                          />
                        </td>
                        <td valign="top">
                          <Field
                            component={DropDownList}
                            key={"Unit" + item.id}
                            id={"Unit" + item.id}
                            name={"Unit" + item.id}
                            data={this.state.units}
                            data-value={item.id}
                            textField={"value"}
                            onChange={this.onUnitChange}
                            value={item.unit}
                            defaultValue={item.unit}
                          />
                          {item.otherUnit.status && (
                            <Field
                              style={{
                                marginTop: "5px",
                                width: "100%",
                                backgroundColor: "#d9d9d9",
                              }}
                              component={Input}
                              defaultValue={item.otherUnit.value}
                              data-value={item.id}
                              value={item.otherUnit.value}
                              onChange={this.onOtherUnitChange}
                            />
                          )}
                        </td>
                        <td valign="top">
                          <Field
                            component={DropDownList}
                            key={"Reason" + item.id}
                            id={"Reason" + item.id}
                            name={"Reason" + item.id}
                            data={this.state.reasons}
                            data-value={item.id}
                            textField={"value"}
                            value={item.reason}
                            defaultValue={item.reason}
                            onChange={this.onReasonChange}
                          />
                          {item.otherReason.status && (
                            <Field
                              style={{
                                marginTop: "5px",
                                width: "100%",
                                backgroundColor: "#d9d9d9",
                              }}
                              component={Input}
                              defaultValue={item.otherReason.value}
                              data-value={item.id}
                              value={item.otherReason.value}
                              onChange={this.onOtherReasonChange}
                            />
                          )}
                        </td>
                        <td align="right" valign="top">
                          <Field
                            style={{
                              marginTop: "10px",
                            }}
                            id={"cbk" + item.id}
                            name={"cbk" + item.id}
                            key={"cbk" + item.id}
                            data-value={item.id}
                            component={Checkbox}
                            onClick={this.onDelete}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  <tr key={uuidv4()}>
                    <td align={"right"} colSpan={6}>
                      <Button
                        type={"button"}
                        style={{
                          marginTop: "5px",
                        }}
                        className="k-button k-primary"
                        onClick={this.addItem}
                      >
                        Add
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        )}
      </>
    );
    return <React.Fragment>{panel}</React.Fragment>;
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Waste);
